import React from 'react'
import classNames from 'classnames'

import Avatar from 'shared/components/community/components/avatar/Avatar'
import Button from 'shared/components/community/components/button/Button'

import { COMMUNITY_MEMBERS_ROLES } from 'constants/communities.constants'

import './member-item.scss'

const MembersListItem = ({ member, handleMuteUnmute, isPayerCabinet = false, handleFilterByUser }) => {
  const { avatar = [{}], muted = false, role, username, postsCount, id: memberId } = member
  const { cropped, original } = avatar[0] || {}

  const wrapperClassName = classNames('member-list-item', {
    'member-list-item--muted': muted,
  })

  const isOwner = role === COMMUNITY_MEMBERS_ROLES.owner
  const avatarImageUrl = cropped ? cropped : original

  return (
    <div className={wrapperClassName}>
      <div className='member-list-item__left-part'>
        <Avatar imageUrl={avatarImageUrl} />
        <div className='member-list-item__details'>
          <div>
            <span className='member-list-item__username'>{username}</span>
            {isOwner && <span className='member-list-item__label'>{I18n.t('react.shared.comminity.admin_label')}</span>}
          </div>
          <div className='member-list-item__posts-count'>
            {I18n.t('react.shared.comminity.posts_count_label', { count: postsCount })}
          </div>
        </div>
      </div>
      <div className='member-list-item__right-part'>
        {!isPayerCabinet && (
          <Button onClick={() => handleMuteUnmute(memberId, muted)} outline>
            {muted ? I18n.t('react.shared.community.unmute_user') : I18n.t('react.shared.community.mute_user')}
          </Button>
        )}
        <Button onClick={() => handleFilterByUser(member)}>{I18n.t('react.shared.button.view_posts')}</Button>
      </div>
    </div>
  )
}

export default MembersListItem
